/* eslint-disable max-len */
import Vue from 'vue';
//import {Amplify} from 'aws-amplify';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
//import '@aws-amplify/ui-vue';

/*
Amplify.configure({
  Auth: {
    region: 'ap-southeast-2',
    userPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    mandatorySignIn: false,
    oauth: {
      domain: process.env.VUE_APP_COGNITO_DOMAIN,
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${process.env.VUE_APP_BASE_URL || 'http://localhost:8081/'}signin`,
      redirectSignOut: process.env.VUE_APP_BASE_URL || 'http://localhost:8081/',
      responseType: 'code',
      label: 'Sign in with Betmakers SSO',
    },
  },
});
*/

Vue.config.productionTip = false;

// global router guard
router.beforeEach((to, from, next) => {
  if(to.matched.some(r=>r.meta.authRequired)){
    if (!store.state.loggedIn) {
      next({ name: 'signin' })
    }
    else{
      next()
    }
  }
  else {
    next();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
